import { Mail } from "lucide-react";
import { useAuth } from "@/features/auth/hooks/useAuth";
import { H4 } from "@/shared/ui/typographies/h4";
import { P } from "@/shared/ui/typographies/paragraph";

export const FirstSignInInfo = () => {
  const { isFirstSignInRequired } = useAuth();

  if (!isFirstSignInRequired) return null;

  return (
    <div className="space-y-6 mt-4" data-testid="first-sign-in-info">
      <div className="flex flex-col items-start gap-3">
        <div className="space-y-3 rounded-lg bg-gray-50 p-4 dark:bg-gray-800/50">
          <div className="space-y-1">
            <H4>Sécurisation de votre compte</H4>
            <P className="text-sm underline text-gray-600 dark:text-gray-400">
              Vous vous êtes connecté avec un mot de passe temporaire
            </P>
          </div>
          <P className="text-sm leading-relaxed text-gray-700 dark:text-gray-300">
            Pour des raisons de sécurité, ce mot de passe ne peut pas être conservé : les emails peuvent être consultés ou transférés à des tiers.
          </P>
          <P className="text-sm leading-relaxed text-gray-700 dark:text-gray-300">
            Afin de garantir que vous seul connaissez votre mot de passe, nous vous demandons d'en définir un nouveau.
          </P>
        </div>
      </div>

      <div className="flex items-start gap-3 rounded-lg border border-indigo-200 bg-indigo-50 p-4 dark:border-indigo-800 dark:bg-indigo-900/30">
        <Mail size={20} className="mt-0.5 shrink-0 text-primary dark:text-indigo-400" />
        <div className="space-y-1">
          <P className="text-sm text-primary dark:text-indigo-100">
            Un lien sécurisé vient de vous être envoyé par email.
          </P>
          <P className="text-sm font-medium text-primary dark:text-indigo-300">
            Cette étape est obligatoire pour accéder à l'application.
          </P>
        </div>
      </div>
    </div>
  );
};
